import { isSelectedIndustryCustom } from "app/pages/industry-analysis/common/getSelectedCategory";
import { PageContainer } from "app/pages/industry-analysis/common/styledComponents";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";
import styled from "styled-components";

const NoDataContainer = styled(PageContainer)`
    height: 400px;
    justify-content: center;
`;

export const WithNoCustomIndustryHOC = (Component) =>
    function (props) {
        if (isSelectedIndustryCustom()) {
            return (
                <NoDataContainer>
                    <NoDataLandscape
                        title={"market.research.page.doesnt.support.custom.industry.title"}
                        subtitle={"market.research.page.doesnt.support.custom.industry.subtitle"}
                    />
                </NoDataContainer>
            );
        }
        return <Component {...props} />;
    };
